/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';

import Grid from '../../../../../../SharedModules/Table/TableGridWithFeatures';
import { CMS_UROA_TABLEHEAD } from '../../../utility/tableHeads';
import CustomDateComponent from '../../CustomDateComponent';
import CommentVisibleIcon from '../../../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import ViewHistoryComponent from '../../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { setCurrentNDCDetailsSelected } from '../../../store/action';

const CMSUROATableComponent = ({
  setRowSelected,
  setGridApi,
  setColumnApi,
  setFullScreen,
}) => {
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const dispatch = useDispatch();
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [corrId, setCorrId] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [gridParams, setGridParams] = React.useState(null);

  const onGridReady = (params) => {
    setGridParams(params);
    setColumnApi(params.columnApi);
  };

  useEffect(() => {
    return () => {
      setGridApi(null);
      setColumnApi(null);
    };
  }, []);

  const handleFullScreenViewClick = () => {
    setFullScreenView(!fullScreenView);
    setFullScreen(!fullScreenView);
  };
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        currentNDCDetailsSelected?.cmsUroaVOs?.length > 0 &&
        currentNDCDetailsSelected?.cmsUroaVOs?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      const temp = { ...currentNDCDetailsSelected };
      temp.cmsUroaVOs = tempObj;
      dispatch(setCurrentNDCDetailsSelected(temp, 'cmsUroaVOs'));
      // eslint-disable-next-line no-unused-expressions
      if (gridParams?.api) gridParams?.api?.refreshCells();
    }
  }, [commentsList]);
  return (
    <div className='table-container eightRecords mt-3 col-12'>
      <Grid
        gridHeight={fullScreenView ? '100vh' : 350}
        rowData={
          (currentNDCDetailsSelected && currentNDCDetailsSelected.cmsUroaVOs) ||
          []
        }
        defaultCol={{ editable: false }}
        fullScreenView={fullScreenView}
        columnDefs={CMS_UROA_TABLEHEAD}
        data-testid='onEditingStopped'
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        fileName='CMS UROA'
        onGridReady={onGridReady}
        onSelect={(e) => {
          setRowSelected(e.data);
        }}
        frameworkComponents={{
          ActionCellRender: (cellInfo) => {
            if (cellInfo?.data?.isBottomRow) {
              return null;
            }
            return (
              <div
                className='tdCell icon-btn-group'
                data-testid='action-column'
              >
                {showComments ? (
                  <Button
                    onClick={() => {
                      setCorrLinkId(cellInfo.data?.corrLinkId);
                      setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                      setShowComments(true);
                    }}
                    tabIndex={'0'}
                    onKeyDown={(e) => {
                      // Handle Enter and Space key events
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault(); // Prevents the default space scrolling behavior
                        setCorrLinkId(cellInfo.data?.corrLinkId);
                        setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                        setShowComments(true);
                      }
                    }}
                    aria-label='Comment'
                    className={`th-ic comment-ic ${
                      parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                        ? 'frr-enabled-comment-btn'
                        : 'frr-disabled-comment-btn'
                    }`}
                    variant='text'
                  >
                    {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                      <img alt='' src={CommentVisibleIcon} />
                    ) : (
                      <img alt='' src={CommentIcon} />
                    )}
                  </Button>
                ) : (
                  <OverlayTrigger
                    placement='bottom'
                    overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
                  >
                    <Button
                      disabled={cellInfo.data?.corrLinkId === 'new'}
                      onClick={() => {
                        setCorrLinkId(cellInfo.data?.corrLinkId);
                        setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                        setShowComments(true);
                      }}
                      tabIndex={'0'}
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          setCorrLinkId(cellInfo.data?.corrLinkId);
                          setCorrId(cellInfo?.data?.labelerCode); // check setCorrId
                          setShowComments(true);
                        }
                      }}
                      aria-label='Comment'
                      className={`th-ic comment-ic ${
                        parseInt(cellInfo.data?.ccCommentsExist, [0, 1]) === 1
                          ? 'frr-enabled-comment-btn'
                          : 'frr-disabled-comment-btn'
                      }`}
                      variant='text'
                    >
                      {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                        <img alt='' src={CommentVisibleIcon} />
                      ) : (
                        <img alt='' src={CommentIcon} />
                      )}
                    </Button>
                  </OverlayTrigger>
                )}
              </div>
            );
          },
          dateComponent: CustomDateComponent,
        }}
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName='CMS_UROA'
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={corrId}
        />
      ) : null}
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='CMS_UROA'
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default CMSUROATableComponent;
